import { Color } from 'src/utils/theme';
import styled, { css } from 'styled-components';

export const LoaderContainer = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s32} auto 0 auto;
    width: ${theme.sz.s20};
  `,
);

export const Container = styled.div<{ $bgColor: Color }>(
  ({ theme, $bgColor }) => css`
    background-color: ${theme.co[$bgColor]};
    border-radius: ${theme.bo.medium};
    padding: ${theme.sz.s3} ${theme.sz.s4};

    @media (max-width: ${theme.sz.m}) {
      border-radius: 0;
    }
  `,
);

export const Header = styled.div<{ $bgColor: Color }>(
  ({ theme, $bgColor }) => css`
    display: grid;
    grid-template-columns: 1fr auto;
    padding: ${theme.sz.s3} ${theme.sz.s4};
    cursor: pointer;
    background-color: ${theme.co[$bgColor]};
    gap: ${theme.sz.s2};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};
    color: ${theme.co.secondary0};
    margin: 0;
    flex: 1;

    @media (max-width: ${theme.sz.m}) {
      ${theme.typography.button.l};
    }
  `,
);

export const Count = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary20};
    margin: 0;

    @media (max-width: ${theme.sz.m}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const IconWrapper = styled.button<{ $isExpanded?: boolean }>(
  ({ theme, $isExpanded }) => css`
    transform: rotate(${$isExpanded ? '180deg' : '0deg'});
    color: ${theme.co.neutral50};
    font-size: ${theme.sz.s6};
    height: max-content;
    display: flex;
    margin-top: ${theme.sz.s1};
    background: none;
    border: none;
    cursor: pointer;
  `,
);

export const Content = styled.ul(
  ({ theme }) => css`
    padding: 0 ${theme.sz.s4};
    min-width: 100%;
    margin: 0;
  `,
);
